export default __webpack_public_path__ + "static/media/pending.368b022d.svg";